<template>
  <section class="md:container mb-[40px] md:mb-[80px] px-5 lg:px-0">
    <article class="featured-article">
      <!-- Information -->
      <div class="featured-article__info">
        <!-- Title -->
        <div class="featured-article__info-title">
          <h3 :title="featuredArticle.title" v-html="featuredArticle.title" />
        </div>
        <!-- ./Title -->

        <!-- Post Info -->
        <DateAndMinRead :post-date="featuredArticle.date" :min-read="3" />
        <!-- ./Post Info -->

        <!-- Read More Button -->
        <div class="featured-article__info-read-more font-cocogoose text-16">
          <a :aria-label="$i18n('blog.read-more')" :href="`/blog/${featuredArticle.slug}/`">
            {{ $i18n('blog.read-more') }}
          </a>
        </div>
        <!-- ./Read More Button -->
      </div>
      <!-- ./Information -->

      <!-- Featured Image -->
      <div class="featured-article__image">
        <!-- Category -->
        <div v-if="featuredArticle.categories && featuredArticle.categories.length" class="featured-article__category">
          <a :href="`/blog/${featuredArticle.categories[0].slug}/`" :aria-label="featuredArticle.categories[0].name">
            {{ featuredArticle.categories[0].name }}
          </a>
        </div>
        <!-- ./Category -->

        <!-- Image -->
        <a :href="`/blog/${featuredArticle.slug}/`" :aria-label="featuredArticle.title">
          <img v-if="featuredArticle.thumbnail" :src="featuredArticle.thumbnail" :alt="featuredArticle.title" />
        </a>
        <!-- ./Image -->
      </div>
      <!-- ./Featured Image -->
    </article>
  </section>
</template>
<script>
import DateAndMinRead from '~/components/blog/DateAndMinRead.vue';

export default {
  name: 'FeaturedArticle',
  components: {
    DateAndMinRead,
  },
  props: {
    featuredArticle: {
      type: [String, Object],
      default: () => {},
    },
  },
};
</script>
<style lang="scss">
.featured-article {
  @apply justify-between w-full flex md:flex-row flex-col-reverse md:items-center h-full gap-[20px] md:gap-[40px];

  &__info {
    @apply flex flex-col gap-[12px] md:gap-[22px];

    &-title {
      @apply break-words text-[16px] md:text-[28px] font-cocogoose leading-normal md:leading-[46px];
    }

    &-read-more {
      @apply w-full flex mt-[20px];

      & > a {
        @apply px-[20px] py-[9px] bg-orange-500 hover:bg-orange-600 duration-200 rounded-[4px] text-white font-cocogoose;
      }
    }
  }

  &__category {
    & > a {
      @apply absolute top-0 left-0 rounded-br-[4px] h-[30px] bg-black text-white py-[5px] px-[10px] text-[13px] uppercase z-20 leading-normal;
    }
  }

  &__image {
    @apply relative flex-shrink-0 max-w-[730px] max-h-[535px] overflow-hidden rounded-[4px];

    &:hover {
      & > a > img {
        @apply scale-110;
      }
    }

    & > a > img {
      @apply duration-500 max-w-full h-auto;
    }
  }
}
</style>
